export enum ChatMessageAction {
  INIT_CHATBOT = 'chatmessage/INIT_CHATBOT',
  LOAD_CHATBOT_MESSAGE = 'chatmessage/LOAD_CHATBOT_MESSAGE',

  START_CHATBOT = 'chatmessage/START_CHATBOT',
  RETURN_ROOT_MESSAGE = 'chatmessage/RETURN_ROOT_MESSAGE',
  RETURN_ROOT = 'chatmessage/RETURN_ROOT',
  RETURN_PREV_QUESTION = "chatmessage/RETURN_PREV_QUESTION",

  FETCH_CHATBOT_DATA_REQUEST = 'chatmessage/FETCH_CHATBOT_DATA',
  FETCH_CHATBOT_DATA_SUCCESS = 'chatmessage/FETCH_CHATBOT_DATA_SUCCESS',
  FETCH_CHATBOT_DATA_FAILURE = 'chatmessage/FETCH_CHATBOT_DATA_FAILURE',

  REACTION_PROCESS = 'chatmessage/REACTION_PROCESS',
  START_REACTION = 'chatmessage/START_REACTION',
  ADD_MESSAGE = 'chatmessage/ADD_MESSAGE',
  REPLY_MESSAGE = 'chatmessage/REPLY_MESSAGE',
  END_REACTION = 'chatmessage/END_REACTION',
  END_MESSAGE = "chatmessage/END_MESSAGE",

  INSERT_VISIT_LOG_REQUEST = 'chatmessage/INSERT_VISIT_LOG_REQUEST',
  INSERT_VISIT_LOG_SUCCESS = 'chatmessage/INSERT_VISIT_LOG_SUCCESS',
  INSERT_VISIT_LOG_FAILURE = 'chatmessage/INSERT_VISIT_LOG_FAILURE',

  INPUT_CHATBOT_MESSAGE = 'chatmessage/INPUT_CHATBOT_MESSAGE',
  FETCH_KEYWORD_DATA_REQUEST = 'chatmessage/FETCH_KEYWORD_DATA_REQUEST',
  FETCH_KEYWORD_DATA_SUCCESS = 'chatmessage/FETCH_KEYWORD_DATA_SUCCESS',
  FETCH_KEYWORD_DATA_FAILURE = 'chatmessage/FETCH_KEYWORD_DATA_FAILURE',

  GET_ANSWER_REQUEST = 'chatmessage/GET_ANSWER_REQUEST',
  GET_ANSWER_SUCCESS = 'chatmessage/GET_ANSWER_SUCCESS',
  GET_ANSWER_FAILURE = 'chatmessage/GET_ANSWER_FAILURE'
}

export const Sender = {
  OPERATOR: 'OPERATOR',
  CUSTOMER: 'CUSTOMER'
};

export const ReactionItemType = {
  CUSTOMER: 'CUSTOMER',
  OPERATOR: 'OPERATOR',
  OPERATOR_ANSWER: 'OPERATOR_ANSWER'
};

export enum ChatImagePosition {
	A = "A",
	B = "B"
}

export enum ChatImageTarget {
	THIS = "THIS",
	NEW = "NEW"
}

export interface IChatImage {
	position: ChatImagePosition;
	url: string;
	hasLink: boolean;
	link: string;
	target: ChatImageTarget;
	isDelete: boolean;
}

export interface INode {
  id: string;
  prev_id?: string;
  title?: string;
  keyword?: string[];
  path: string;
  type: string;
  content: string;
  isRoot?: boolean;
  children: string[];
  isEdit: boolean;
  isSelect: boolean;
  destinationId?: string;
  endMessage?: string;
  chatImages?: IChatImage[];
}

export interface INodeList {
  [index: string]: INode;
}

export type IMessage = {
  message_id: string
  chatdata_id: string
  prev_id?: string
  type: string
  text: string
  like_btn?: boolean
  return_btn?: boolean
  chatImages?: IChatImage[]
}
export interface ChatData {
  [index: string]: INode
}

interface StartChatbotAction {
  type: ChatMessageAction.START_CHATBOT
  payload: {
    message: string
  }
}

interface AddMessageAction {
  type: ChatMessageAction.ADD_MESSAGE
  payload: {
    id: string
    type: string
    text: string
  }
}

interface ReplyMessageAction {
  type: ChatMessageAction.REPLY_MESSAGE
  payload: {
    id: string
    prev_id: string
    type: string
    text: string
    reactionType: string
    chatImages?: IChatImage[]
  }
}
interface ReactionProcessAction {
  type: ChatMessageAction.REACTION_PROCESS
  payload: {
    type: string
    text: string
  }
}

interface ReturnRootAction {
  type: ChatMessageAction.RETURN_ROOT
}

interface RetrunPrevQuestionAction {
  type: ChatMessageAction.RETURN_PREV_QUESTION
  payload: {
    data: INode
  }
}

interface EndMessageAction {
  type: ChatMessageAction.END_MESSAGE
  payload: {
    message: string
  }
}

interface InputChatMessageAction {
  type: ChatMessageAction.INPUT_CHATBOT_MESSAGE
}

export interface IFetchKeywordData {
  type: ChatMessageAction.FETCH_KEYWORD_DATA_REQUEST
  payload: {
    message: string
    chatbasedata: INodeList
  }
}

interface FetchChatbotDataSuccess {
  type: ChatMessageAction.FETCH_CHATBOT_DATA_SUCCESS
  payload: {
    chatbotData: ChatData
  }
}

interface FetchKeywordDataSuccess {
  type: ChatMessageAction.FETCH_KEYWORD_DATA_SUCCESS
  payload: {
    keywords: string[]
    chatbasedata: INodeList
  }
}
interface FetchKeywordDataFailure {
  type: ChatMessageAction.FETCH_KEYWORD_DATA_FAILURE;
}

interface ReturnRootMessage {
  type: ChatMessageAction.RETURN_ROOT_MESSAGE
}

interface LoadChatBotMessage {
  type: ChatMessageAction.LOAD_CHATBOT_MESSAGE;
  payload: {
    data: IMessage[];
  };
}

export type ChatMessageActionTypes =
  | StartChatbotAction
  | AddMessageAction
  | ReplyMessageAction
  | ReactionProcessAction
  | ReturnRootAction
  | RetrunPrevQuestionAction
  | EndMessageAction
  | InputChatMessageAction
  | IFetchKeywordData
  | FetchKeywordDataSuccess
  | FetchChatbotDataSuccess
  | ReturnRootMessage
  | LoadChatBotMessage
  | FetchKeywordDataFailure;
